import { FEATURE } from '~/common/enums/feature.enum';
// todo: move to the common domain
import GamecenterDetailPage from '~/domains/contest/domains/gamecenter/pages/detail';
import { serverFlags } from '~/domains/feature-flags/serverFlags';
import {
  isContestV2Id,
  resolveContestUuidRedirect,
} from '~/domains/contest/domains/common/utils/resolveContestUuidRedirect';
import { getContest } from '~/services/contests/contests.service.api';

export async function getServerSideProps({
  params,
  query,
}: {
  params: { contestUuid: string };
  query: { contestUuid: string } & Record<string, string | string[] | undefined>;
}) {
  const { contestUuid } = params;

  // v2 contests (contest_… ids) aren't served by the v1 detail fetch — resolve to the
  // v2 game center instead of 500ing on getContest. Mirrors the bare /contest/[id] route
  // (Next already includes contestUuid in query, and ...restQuery forwards utm/referral).
  if (isContestV2Id(contestUuid)) {
    return resolveContestUuidRedirect(query);
  }

  const fullContest = await getContest(contestUuid);

  const isDynamicContestLinkPreviewEnabled = await serverFlags.getTreatment(
    'anonymous',
    FEATURE.ENABLE_DYNAMIC_CONTEST_LINK_PREVIEW
  );
  const isDynamicContestLinkPreviewBase64Enabled = await serverFlags.getTreatment(
    'anonymous',
    FEATURE.ENABLE_DYNAMIC_CONTEST_LINK_PREVIEW_BASE64
  );
  const isDynamicContestLinkPreviewDeadlineEnabled = await serverFlags.getTreatment(
    'anonymous',
    FEATURE.ENABLE_DYNAMIC_CONTEST_LINK_PREVIEW_DEADLINE
  );

  if (!fullContest) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      fullContest,
      contestUuid,
      isDynamicContestLinkPreviewEnabled: isDynamicContestLinkPreviewEnabled === 'on',
      isDynamicContestLinkPreviewBase64Enabled: isDynamicContestLinkPreviewBase64Enabled === 'on',
      isDynamicContestLinkPreviewDeadlineEnabled:
        isDynamicContestLinkPreviewDeadlineEnabled === 'on',
    },
  };
}

function DetailPage() {
  return <GamecenterDetailPage />;
}

export default DetailPage;

DetailPage.isPublic = true;
DetailPage.hasOwnAppshell = true;
DetailPage.trackingName = 'Contest Detail';
